import { ReactElement } from 'react';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { MeetingModuleCard } from '../meeting-card/meeting-card';
import { useInfiniteScroll } from '@components/common';
import { GetMeetings } from '../getMeetings/get-meetings';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';
import { useMeetingFilterStore } from '@store/meetingFilterStore';
import { useMeetingListRBDM } from '@services/hooks/meetings/useMeetingListRBDM';

export const FccMetingList = (): ReactElement => {
	const { isFetching: queryFetch, error } = useMeetingListRBDM();
	const { fccMeetingFilter } = useMeetingFilterStore();
	const { fetchMore, isFetching, result } = GetMeetings({
		...fccMeetingFilter,
		type: 'FCC Meeting',
	});

	useInfiniteScroll(fetchMore);

	return (
		<Wrapper isLoaderVisible={queryFetch || (isFetching && result.length === 0)} isError={error}>
			<ul className="meeting-card-wrapper row">
				{result.length > 0 ? (
					result.map((meeting) => {
						const meetingData = meeting._data;
						return <MeetingModuleCard key={meetingData.id} data={meetingData} />;
					})
				) : (
					<NoDataFound />
				)}
			</ul>
		</Wrapper>
	);
};
